// extracted by mini-css-extract-plugin
export default {"secondaryItemLabel":"secondaryItemLabel--FKq5J"};